import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBNd3dMEH9D5kHPN1c-3nZzk62VEfdU2Kc",
  authDomain: "gestao-financeira01.firebaseapp.com",
  projectId: "gestao-financeira01",
  storageBucket: "gestao-financeira01.firebasestorage.app",
  messagingSenderId: "233830457410",
  appId: "1:233830457410:web:984b99b469fe0830324ddb",
  measurementId: "G-QB37M2X339"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);